import { rand, randWord, randRecentDate, randNumber, randAirportCode } from '@ngneat/falso';
import { optional } from '@library/common/functions';

import {
   Milestones,
   InternationalShipment, TrafficDirections,
   InternationalRoadShipment,
   InternationalAirShipment, AwbTypes,
   InternationalOceanShipment, ShippingTypes,
} from '../shipment';

import { MockShipment } from './shipment.mock';
import { MockCustoms } from './customs.mock';
import { MockContainer } from './containers.mock';

export class MockInternationalShipment extends InternationalShipment {
   constructor() {
      super({
         ...new MockShipment(),
         movementType: {
            from: Math.random() > 0.5 ? 'door' : 'port',
            to: Math.random() > 0.5 ? 'door' : 'port'
         },
      });

      if ( optional() ) { this.incoterms = randWord(); }
      if ( optional() ) { this.customs = new MockCustoms(); }
      if ( optional() ) { this.trafficDirection = rand([ ...TrafficDirections ]); }
   }
}

export class MockInternationalRoadShipment extends InternationalRoadShipment {
   constructor() {
      super( new MockInternationalShipment() );
   }
}

export class MockInternationalAirShipment extends InternationalAirShipment {
   constructor() {
      super( new MockInternationalShipment() );

      this.milestones = Milestones( 'air' );
      if ( optional() ) { this.awbType = rand([ ...AwbTypes ]); }
      Object.keys( this.milestones ).map( key => {
         if ( optional() ) {
            this.milestones[key] = randRecentDate({ days: 10 });
         }
      });
   }
}

export class MockInternationalOceanShipment extends InternationalOceanShipment {
   constructor() {
      super( new MockInternationalShipment() );

      this.itemsType = optional() ? 'LCL' : 'FCL';
      if ( this.itemsType === 'FCL' ) {
         this.itemized = optional();
         this.containers = Array.from({ length: randNumber({ max: 9 }) + 1 }, _ => new MockContainer( this.itemized ));
      }

      if ( optional() ) { this.shippingType = rand([ ...ShippingTypes ]); }
      if ( optional() ) { this.teu = randNumber({ max: 10 }); }
      if ( optional() ) {
         this.origin = randAirportCode();
         this.destination = randAirportCode();
      }

      this.milestones = Milestones( 'ocean' );
      Object.keys( this.milestones ).map( key => {
         if ( optional() ) {
            this.milestones[key] = randRecentDate({ days: 10 });
         }
      });
   }
}
